import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';

@Component({
  selector: 'app-trip-activity-log',
  templateUrl: './trip-activity-log.component.html',
  styleUrls: ['./trip-activity-log.component.css']
})
export class TripActivityLogComponent implements OnInit {
  activityLog = [];
  search;
  @Input() tripData;
  @Output() onCloseModal = new EventEmitter<any>()

  preServiceAreas = {};
  preCooperates = {};


  constructor(
    private assignTripService: AssigTripsService,
    private corporateService : CorporateService
  ) { }

  ngOnInit() {
    this.getTripLog();
    this.getCorporate();
  }

  getTripLog() {
    this.assignTripService.getTripActivityLog(this.tripData._id)
      .pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
        if (data) {
          this.activityLog = data
        }
      })
  }

  

    getCorporate() {
      this.corporateService
        .getCorporateUsers('active')
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data ) {
            this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }
  

  onClose() {
    this.onCloseModal.emit()
  }

  ngOnDestroy(): void {

  }
}
